import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, MenuItem } from "@mui/material";
import { useFormContext } from "react-hook-form";
import CustomDatePicker from "../../../components/CustomDatePicker";

import CustomTextField from "../../../components/CustomTextField";
import ReactHookFormSelect from "../../../components/ReactHookFormSelect";
import SearchableAutoComplete from "../../../components/SearchableAutoComplete";
import useTenant from "../../../hooks/useTenant";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

function AgreementTrackerFields(props) {
  const { t } = useTranslation();
  const { fields } = props;
  const {
    formState: { errors },
    control,
  } = useFormContext();

  const { autoSearchTenant, tenantAutoSearchResults } = useTenant();

  const [tenantOptions, setTenantOptions] = useState([]);
  const [tenantPayload, setTenantPayload] = useState(currentPayload);

  const fetchTenant = async () => {
    await autoSearchTenant(tenantPayload);
  };
  useEffect(() => {
    fetchTenant();
  }, [tenantPayload]);

  useEffect(() => {
    console.log(tenantAutoSearchResults, "tenantAutoSearchResults");
    if (tenantAutoSearchResults && tenantAutoSearchResults.data.length !== 0) {
      const results = [...tenantOptions, ...tenantAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setTenantOptions(filteredResults);
    }
  }, [tenantAutoSearchResults]);

  return (
    <Grid container spacing={6} className="row">
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <SearchableAutoComplete
          name="tenant"
          label={t("franchise_name")}
          control={control}
          data={tenantOptions}
          payload={tenantPayload}
          setPayload={setTenantPayload}
          loading={false}
          multiple={false}
          defaultValue={""}
          hasNextPage={false}
          fields={fields}
          fullWidth
          variant="outlined"
          errors={errors}
        ></SearchableAutoComplete>
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomDatePicker
          name="dateOfAgreement"
          nameTemp="dateOfAgreementStr"
          label={t("date_of_agreement")}
          range={false}
          control={control}
          fields={fields}
          timePicker={true}
          format="DD-MM-YYYY"
          conversionFormat="YYYY-MM-DD"
        />
      </Grid>
    </Grid>
  );
}

export default AgreementTrackerFields;
